const STORAGE_TYPES = <const>{
  local: window.localStorage,
  session: window.sessionStorage,
}

export type Types = keyof typeof STORAGE_TYPES

const formatToJson = (value: any) =>
  value &&
  (Object.prototype.toString.call(value) === '[object Object]' ||
    Array.isArray(value))

const formatData = (data: any) => {
  const rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/

  if (data === 'true') {
    // true
    return true
  } else if (data === 'false') {
    // false
    return false
  } else if (data === 'null') {
    // null
    return null
  } else if (data === 'undefined') {
    // undefined
    return void 0
  } else if (`${+data}` === data) {
    // number
    return +data
  } else if (rbrace.test(data)) {
    // json
    try {
      return JSON.parse(data)
    } catch (err) {
      return {}
    }
  }

  return data
}

const getStorageFunc = (type: Types) => STORAGE_TYPES[type]

export const put = (key: string, value: any, type: Types = 'local') => {
  const isJson = formatToJson(value)
  getStorageFunc(type).setItem(key, isJson ? JSON.stringify(value) : value)
}

export const get = <T extends any>(
  key: string,
  defaultValue?: T,
  type: Types = 'local'
): T => {
  const data = getStorageFunc(type).getItem(key)
  if (data === null && defaultValue !== undefined) {
    return defaultValue
  }

  return <T>formatData(data)
}

export const remove = (key: string, type: Types = 'local') => {
  return getStorageFunc(type).removeItem(key)
}

export const clear = (type: Types = 'local') => {
  getStorageFunc(type).clear()
}

type Key2Val<T extends Types> = {
  [key in T]: key
}
export const type: Key2Val<Types> = <const>{
  local: 'local',
  session: 'session',
}
